import { useState } from 'react';
import '../tailwind.css';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../../components/Reporting/ui/card';
import ReportForm from '../../../components/Reporting/report-form';
import SalesByCategoryList from '../../../components/Reporting/sales-by-category-list';
import { REPORT_PROVIDERS } from '../../../components/Reporting/shared/schema';
import { HeaderMenu } from '../../../components/Reporting/header-menu';
import instance from '../../../services/api';
import { toast } from 'react-toastify';
import { Tag } from 'lucide-react';

export default function SalesByCategoryPage() {
  const [categories, setCategories] = useState([]);
  const [hasReport, setHasReport] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleFormSubmit = async (data) => {
    setIsLoading(true);
    setCategories([]);
    setHasReport(false);

    try {
      const requestBody = {
        businessUuid: data.businessUuid,
        businessId: data.businessId,
        startDate: data.startDate,
        endDate: data.endDate,
        startTime: data.startTime,
        endTime: data.endTime,
        filter: data.filter || 'all',
        useLocalTime: data.useLocalTime || false,
        providers: data.providers || REPORT_PROVIDERS,
      };

      const response = await instance.post(
        '/reports/sales-by-category',
        requestBody
      );

      setCategories(response.data.categories || []);
      setHasReport(true);

      toast.success('Sales By Category Report Generated Successfully');

      setTimeout(() => {
        document.getElementById('sales-by-category-report')?.scrollIntoView({
          behavior: 'smooth',
        });
      }, 100);
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Failed to generate sales by category report. Please try again.';
      toast.error(errorMessage);
      setCategories([]);
      setHasReport(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <HeaderMenu
        currentPage="sales-by-category"
        reportData={hasReport ? { categories } : null}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Report Form */}
        <Card className="no-print mb-8">
          <CardHeader>
            <CardTitle className="flex items-center">
              <Tag className="text-primary mr-3 h-6 w-6" />
              Generate Sales By Category Report
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ReportForm
              onSubmit={handleFormSubmit}
              isLoading={isLoading}
              setReportData={() => {
                setCategories([]);
                setHasReport(false);
              }}
              showSections={false}
            />
          </CardContent>
        </Card>

        {/* Loading State */}
        {isLoading && (
          <Card className="mb-8">
            <CardContent className="pt-8">
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary mr-3"></div>
                <span className="text-foreground">Generating report...</span>
              </div>
            </CardContent>
          </Card>
        )}

        {/* Sales By Category Report Output */}
        {!isLoading && hasReport && (
          <div id="sales-by-category-report">
            <SalesByCategoryList categories={categories} />
          </div>
        )}
      </div>
    </div>
  );
}
